const OPFS_DIRECTORY = 'cinematic-assets';

export function isOpfsAvailable(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    typeof navigator.storage?.getDirectory === 'function' &&
    typeof FileSystemHandle !== 'undefined'
  );
}

export function safeAssetFileName(assetId: string): string {
  const sanitized = assetId.replace(/[^a-z0-9-]+/gi, '-').replace(/(^-|-$)/g, '');
  return sanitized || 'asset';
}

export function assetOpfsKey(assetId: string): string {
  return `${OPFS_DIRECTORY}/${safeAssetFileName(assetId)}`;
}

async function opfsDirectory(): Promise<FileSystemDirectoryHandle | null> {
  if (!isOpfsAvailable()) return null;
  try {
    const root = await navigator.storage.getDirectory();
    return await root.getDirectoryHandle(OPFS_DIRECTORY, { create: true });
  } catch {
    return null;
  }
}

export async function persistAssetBlob(assetId: string, blob: Blob): Promise<boolean> {
  const directory = await opfsDirectory();
  if (!directory) return false;
  try {
    const handle = await directory.getFileHandle(safeAssetFileName(assetId), { create: true });
    const writable = await handle.createWritable();
    await writable.write(blob);
    await writable.close();
    return true;
  } catch (error) {
    console.warn(`OPFS persist failed for ${assetId}`, error);
    return false;
  }
}

export async function readAssetBlob(assetId: string): Promise<Blob | null> {
  const directory = await opfsDirectory();
  if (!directory) return null;
  try {
    const handle = await directory.getFileHandle(safeAssetFileName(assetId));
    return await handle.getFile();
  } catch {
    return null;
  }
}

export async function removeAssetBlob(assetId: string): Promise<void> {
  const directory = await opfsDirectory();
  if (!directory) return;
  try {
    await directory.removeEntry(safeAssetFileName(assetId));
  } catch {
    // entry does not exist — fine
  }
}
